import React, { useState } from 'react';
import './SubjectModules.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronDown, faChevronUp, faFileAlt, faArrowLeft } from '@fortawesome/free-solid-svg-icons';
import { Link } from 'react-router-dom';

// Flatten all subtopics for navigation purposes
const getAllSubtopics = (subtopicsData) => {
  return Object.values(subtopicsData).flat();
};

const DAAModules = () => {
  const modules = [
    'Module 1', 'Module 2', 'Module 3', 'Module 4', 'Module 5', 'Module 6', 'Module 7'
  ];

  const subtopicsData = {
    'Module 1': [
      { name: 'Stages of Algorithm Development', path: '/daa-m1-s1' },
      { name: 'Greedy techniques: Fractional Knapsack Problem', path: '/daa-m1-s2' },
      { name: 'Greedy techniques: Huffman coding', path: '/daa-m1-s3' },
      { name: 'Divide and Conquer: Maximum Subarray', path: '/daa-m1-s4' },
      { name: 'Divide and Conquer:  Karatsuba faster integer multiplication algorithm', path: '/daa-m1-s5' }
    ],
    'Module 2': [
      { name: 'Dynamic programming: Matrix Chain Multiplication ', path: '/daa-m2-s1' },
      { name: 'Dynamic programming: Assembly Line Scheduling', path: '/daa-m2-s2' },
      { name: 'Dynamic programming:  Longest Common Subsequence (LCS)', path: '/daa-m2-s3' },
      { name: 'Dynamic programming:   0-1 Knapsack', path: '/daa-m2-s4' },
      { name: 'Backtracking: N-Queens problem', path: '/daa-m2-s5' },
      { name: 'Backtracking: Subset Sum', path: '/daa-m2-s6' },
      { name: 'Backtracking: Graph Coloring', path: '/daa-m2-s7' },
      { name: 'Branch & Bound: LIFO-BB and FIFO BB methods: Job Selection problem', path: '/daa-m2-s8' },
      { name: 'Branch & Bound:  0-1 Knapsack Problem ', path: '/daa-m2-s9' }
    ],
    'Module 3': [
      { name: 'Naive String-Matching ', path: '/daa-m3-s1' },
      { name: 'KMP Algorithm', path: '/daa-m3-s2' },
      { name: 'Rabin-Karp Algorithm', path: '/daa-m3-s3' }
    ],
    'Module 4': [
      { name: 'Bellman-ford', path: '/daa-m4-s1' },
      { name: 'Floyd Warshall', path: '/daa-m4-s2' },
      { name: 'Ford-Fulkerson ', path: '/daa-m4-s3' },
      { name: 'Edmond Karp', path: '/daa-m4-s4' },
      { name: 'Push Relabel  ', path: '/daa-m4-s5' }
    ],
    'Module 5': [
      { name: ' Line Segments: Properties, Intersection, sweeping lines', path: '/daa-m5-s1' },
      { name: 'Convex Hull: Graham’s Scan ', path: '/daa-m5-s2' },
      { name: 'Convex Hull: Jarvis’ March Algorithm ', path: '/daa-m5-s3' }
    ],
    'Module 6': [
      { name: 'Randomized Quick Sort', path: '/daa-m6-s1' },
      { name: 'Hiring Problem', path: '/daa-m6-s2' },
      { name: 'Global Minimum Cut Problem', path: '/daa-m6-s3' }
    ],
    'Module 7': [
      // Empty for now
    ]
  };

  const [openModule, setOpenModule] = useState(null);

  // Get all flattened subtopics for navigation
  const allSubtopics = getAllSubtopics(subtopicsData);

  const toggleSubtopics = (module) => {
    setOpenModule(openModule === module ? null : module);
  };

  return (
    <div className="subjectbody">
      <Link to="/courses" className="return-to-course-btn">
        <FontAwesomeIcon icon={faArrowLeft} style={{ marginRight: '8px' }} />
        Back to Courses
      </Link>
      <div className="subject-header">
        <h1>Design and Analysis of Algorithms </h1>
      </div>
      <div className="module-list">
        {modules.map((module) => (
          <div className="module" key={module}>
            <div className="module-header" onClick={() => toggleSubtopics(module)}>
              <span>{module}</span>
              <FontAwesomeIcon icon={openModule === module ? faChevronUp : faChevronDown} />
            </div>
            {openModule === module && (
              <ul className="subtopics">
                {subtopicsData[module].map((topic, index) => (
                  <li key={index}>
                    <span>{topic.name}</span>
                    <Link
                      to={topic.path}
                      className="article-link"
                      state={{ subtopics: allSubtopics, subjectPath: '/subject-DAAModules' }}
                    >
                      <FontAwesomeIcon icon={faFileAlt} />
                    </Link>
                  </li>
                ))}
              </ul>
            )}
          </div>
        ))}
      </div>
    </div>
  );
};

export default DAAModules;
